import React from 'react';

function LFTForm() {
  return (
    <div>
      <h2>LFTForm</h2>
    </div>
  );
}

export default LFTForm;
